/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include3_TitleInputs */

const es_landing_price_include3_title = /** @type {(inputs: Landing_Price_Include3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de pagos`)
};

const gl_landing_price_include3_title = /** @type {(inputs: Landing_Price_Include3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xestión de pagos`)
};

const en_landing_price_include3_title = /** @type {(inputs: Landing_Price_Include3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment handling`)
};

/**
* | output |
* | --- |
* | "Payment handling" |
*
* @param {Landing_Price_Include3_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include3_title = /** @type {((inputs?: Landing_Price_Include3_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include3_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include3_title(inputs)
	if (locale === "en") return en_landing_price_include3_title(inputs)
	return es_landing_price_include3_title(inputs)
});